export const BASE_URL = process.env.GATSBY_AIRTABLE_BASE;
export const TOKEN = process.env.GATSBY_AIRTABLE_TOKEN;

export const CONFIG = {
	headers: {
		'Authorization': `Bearer ${TOKEN}`,
	},
};
